enum Product {
  deals = "deals",
  recognition = "recognition",
  medical = "medical",
  tenantWallet = "tenantWallet",
  userWallet = "userWallet",
  ssoOptions = "ssoOptions",
  tenantOnboarding = "tenantOnboarding",
  zipPayment = "zipPayment",
  wellnessHub = "wellnessHub",
  globalBeta = "globalBeta",
  reportingBeta = "reportingBeta"
}

export default Product
